import { render } from "./swithLanguage.vue?vue&type=template&id=1782b5e8&scoped=true"
import script from "./swithLanguage.vue?vue&type=script&lang=js"
export * from "./swithLanguage.vue?vue&type=script&lang=js"

import "./swithLanguage.vue?vue&type=style&index=0&id=1782b5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1782b5e8"]])

export default __exports__